'use strict';

var Storage = {};

Storage.CookiePreferencesManager = require('./CookiePreferencesManager');
Storage.IPreferencesManager = require('./IPreferencesManager');

Storage._preferenceManager = new Storage.CookiePreferencesManager();
Storage.getPreferenceManager = function() {
    return Storage._preferenceManager;
};

module.exports = Storage;


//////////////////
// WEBPACK FOOTER
// ./mits/Storage/index.js
// module id = 26
// module chunks = 0